export const GET_LIST_MOVIE = 'ScheduleReducer/GET_LIST_MOVIE';
export const GET_LIST_REQUEST = 'ScheduleReducer/GET_LIST_REQUEST';
export const GET_LIST_SUCCESSS = 'ScheduleReducer/GET_LIST_SUCCESSS';
export const GET_LIST_FAILED = 'ScheduleReducer/GET_LIST_FAILED';
export const GET_LIST_CINEMA = 'ScheduleReducer/GET_LIST_CINEMA';
export const GET_LIST_CINEMA_REQUEST = 'ScheduleReducer/GET_LIST_CINEMA_REQUEST';
export const GET_LIST_CINEMA_SUCCESSS = 'ScheduleReducer/GET_LIST_CINEMA_SUCCESSS';
export const GET_LIST_CINEMA_FAILED = 'ScheduleReducer/GET_LIST_CINEMA_FAILED';
export const RESET_SATE = 'ScheduleReducer/RESET_SATE';

